import axios, { AxiosResponse } from 'axios'

import { AddOnRead, AddOnWrite } from '@generated/types'

const BASE_URL = '/api/add-on'

export default {
  async fetchAll(): Promise<AxiosResponse<AddOnRead[]>> {
    return axios.get<AddOnRead[]>(`${BASE_URL}/`)
  },

  async updateAll(data: AddOnWrite[]): Promise<AxiosResponse<AddOnRead[]>> {
    return axios.put(`${BASE_URL}/all/`, data)
  },
}
